export default "__VITE_ASSET__eJd5c4vi__"